import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { customElement as n } from '../../../../node_modules/@lit/reactive-element/decorators/custom-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { CarouselBase } from '../../lit-mixins/carousel-base/index.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import { getProductPreviewPlusSettings } from './settings/carousel-settings.js';
import { renderLayout } from './layout/index.js';
import css_248z$3 from './product-preview-plus.scss.js';
import css_248z$1 from '../../atoms/buttons/generic-button2.0/styles/generic-button-updated.scss.js';
import css_248z from '../../molecules/generic-carousel/generic-carousel.scss.js';
import css_248z$2 from './carousel-pagination-navigation.scss.js';
import '../../atoms/buttons/generic-button2.0/index.js';
import './carousel-pagination-navigation.js';

const LitElementWithUtils = BaseWithUtils(s);
let ProductPreviewPlus = class ProductPreviewPlus extends CarouselBase(LitElementWithUtils) {
    constructor() {
        super(...arguments);
        this.headline = '';
        this.headlineId = 'product-preview-heading';
        this.cards = [];
        this.mainCta = null;
        this.divider = false;
        this.navTemplate = '#number1# of #number2#';
        this.query = '(max-width: 767px)';
        this.isMobile = false;
        this.hasOverflow = true;
        this._previousRtl = false;
        this._swiperInstance = null;
        this._resizeObserver = null;
    }
    handleMediaQuery(event) {
        this.isMobile = event.detail.value;
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this._resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        this._resizeObserver = null;
    }
    firstUpdated() {
        this._previousRtl = this.rtl || isRTL();
        this._initializeCarousel();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('rtl')) {
            const currentRtl = this.rtl || isRTL();
            if (this._previousRtl !== currentRtl && this._swiperInstance) {
                this._previousRtl = currentRtl;
                this._reinitializeCarousel();
            }
        }
    }
    _equalizeCardHeights() {
        var _a, _b;
        const containers = Array.from((_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.product-preview-card__container')) !== null && _b !== void 0 ? _b : []);
        if (!containers.length)
            return;
        // Reset to natural height first so we get accurate measurements
        containers.forEach(el => { el.style.height = ''; });
        // Find tallest after layout
        requestAnimationFrame(() => {
            const maxHeight = containers.reduce((max, el) => Math.max(max, el.getBoundingClientRect().height), 0);
            if (maxHeight > 0) {
                containers.forEach(el => { el.style.height = `${maxHeight}px`; });
            }
        });
    }
    _initializeCarousel() {
        setTimeout(() => {
            var _a;
            this._swiperInstance = this.initCarousel(getProductPreviewPlusSettings);
            this.announceCarouselLoaded();
            this._equalizeCardHeights();
            // Re-equalize on container resize (e.g. font load, viewport change)
            this._resizeObserver = new ResizeObserver(() => this._equalizeCardHeights());
            const swiper = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.swiper');
            if (swiper)
                this._resizeObserver.observe(swiper);
        }, 0);
    }
    _reinitializeCarousel() {
        var _a;
        (_a = this._resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        this._resizeObserver = null;
        if (this._swiperInstance) {
            this._swiperInstance.destroy(true, true);
            this._swiperInstance = null;
        }
        this.requestUpdate();
        this.updateComplete.then(() => {
            requestAnimationFrame(() => {
                setTimeout(() => {
                    var _a;
                    this._swiperInstance = this.initCarousel(getProductPreviewPlusSettings);
                    this._equalizeCardHeights();
                    this._resizeObserver = new ResizeObserver(() => this._equalizeCardHeights());
                    const swiper = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.swiper');
                    if (swiper)
                        this._resizeObserver.observe(swiper);
                }, 50);
            });
        });
    }
    announceCarouselLoaded() {
        var _a;
        const announcement = `Carousel loaded with ${this.cards.length} products. Use arrow keys to navigate.`;
        const liveRegion = document.createElement('div');
        liveRegion.setAttribute('role', 'status');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.className = 'sr-only';
        liveRegion.textContent = announcement;
        (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.appendChild(liveRegion);
        setTimeout(() => liveRegion.remove(), 1000);
    }
    render() {
        var _a;
        const direction = this.rtl || isRTL() ? 'rtl' : 'ltr';
        return this.renderCarousel($ `<section class="convatec-product-preview-plus generic-carousel-container ${direction} ${this.divider ? 'divider' : ''} ${!this.hasOverflow ? 'no-overflow' : ''} ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''}" aria-labelledby="${this.headlineId}" dir="${direction}">${renderLayout(this)}<nav aria-label="Carousel pagination"><carousel-pagination-navigation ?rtl="${this.rtl || isRTL()}" nextText="${this.nextText}" previousText="${this.previousText}"></carousel-pagination-navigation></nav></section>`);
    }
};
ProductPreviewPlus.styles = [
    LitElementWithUtils.styles || [],
    css_248z,
    css_248z$1,
    css_248z$2,
    css_248z$3,
];
__decorate([
    e({ type: String })
], ProductPreviewPlus.prototype, "headline", void 0);
__decorate([
    e({ type: String })
], ProductPreviewPlus.prototype, "headlineId", void 0);
__decorate([
    e({
        type: Array,
        converter: {
            fromAttribute: (value) => {
                if (!value)
                    return [];
                try {
                    const parsed = JSON.parse(value);
                    return Array.isArray(parsed) ? parsed : [];
                }
                catch (e) {
                    console.error('Error parsing cards JSON:', e);
                    return [];
                }
            },
            toAttribute: (value) => JSON.stringify(value),
        },
    })
], ProductPreviewPlus.prototype, "cards", void 0);
__decorate([
    e({
        type: Object,
        converter: {
            fromAttribute: (value) => {
                if (!value)
                    return null;
                try {
                    return JSON.parse(value);
                }
                catch (e) {
                    console.error('Error parsing mainCta JSON:', e);
                    return null;
                }
            },
            toAttribute: (value) => value ? JSON.stringify(value) : null,
        },
    })
], ProductPreviewPlus.prototype, "mainCta", void 0);
__decorate([
    e({ type: Boolean })
], ProductPreviewPlus.prototype, "divider", void 0);
__decorate([
    e({ type: String })
], ProductPreviewPlus.prototype, "navTemplate", void 0);
__decorate([
    t()
], ProductPreviewPlus.prototype, "query", void 0);
__decorate([
    t()
], ProductPreviewPlus.prototype, "isMobile", void 0);
__decorate([
    t()
], ProductPreviewPlus.prototype, "hasOverflow", void 0);
ProductPreviewPlus = __decorate([
    n('product-preview-plus')
], ProductPreviewPlus);

export { ProductPreviewPlus };
